"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _vars = require("../../styles/vars");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

var getFontSize = function getFontSize(p) {
  var size = _vars.textFontSizes[p.size] ? p.size : 'normal';
  return _vars.textFontSizes[size][p.device];
};
var Text = exports.Text = _styledComponents["default"].div.withConfig({
  displayName: "styles__Text",
  componentId: "sc-1org3nd-0"
})(["font-size:", "rem;line-height:1.5;", ";", ";", ";"], getFontSize, function (p) {
  return p.ellipsis && "\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  ";
}, function (p) {
  return p.secondary && "\n    opacity: 0.5;\n  ";
}, function (p) {
  return p.opacity && "\n    opacity: ".concat(p.opacity, ";\n  ");
});
//# sourceMappingURL=styles.js.map